const tryRequire = require('try-require')

module.exports = function create (state, opts, config) {
    try {
        const FaviconsWebpackPlugin = tryRequire('favicons-webpack-plugin')
        const HtmlWebpackExcludeAssetsPlugin = tryRequire('html-webpack-exclude-assets-plugin')

        if (!FaviconsWebpackPlugin || !HtmlWebpackExcludeAssetsPlugin) {
            return {} // waiting for an installation
        }

        config.plugins.push(new FaviconsWebpackPlugin({
            logo: opts.icon,
            prefix: 'icons/',
            statsFilename: 'iconstats-[hash].json',
            persistentCache: true,
            inject: true,
            emitStats: false,
            icons: state.IS_DEV ? {
                android: false,
                appleIcon: false,
                appleStartup: false,
                coast: false,
                favicons: true,
                firefox: false,
                opengraph: false,
                twitter: false,
                yandex: false,
                windows: false
            } : {
                android: true,
                appleIcon: true,
                appleStartup: true,
                coast: false,
                favicons: true,
                firefox: true,
                opengraph: false,
                twitter: false,
                yandex: false,
                windows: false
            }
        }))
        // removing unused assets
        return new HtmlWebpackExcludeAssetsPlugin()
    } catch (error) {
        // is probably still needing some dependency installation
    }
}



// WEBPACK FOOTER //
// ./src/technologies/icons.js